/* src/app/shared/ui/lib/shared-modules/modals/alert-modal/alert-sending-explanation/alert-sending-explanation.component.scss */
:host {
  display: block;
}
.explanation {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid #b7bce0;
  border-radius: 12px;
  background-color: #f8f9ff;
  text-align: start;
}
.explanation__title {
  font-size: 14px;
  font-weight: 500;
  color: #2b3674;
}
.explanation__cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.explanation__card {
  display: flex;
  flex-direction: column;
  flex: 1 1 200px;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background-color: #e4e7f5;
}
.explanation__label {
  align-self: flex-start;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
}
.explanation__label--first {
  background-color: #607bee;
}
.explanation__label--edges {
  background-color: #f89406;
}
.explanation__label--recurring {
  background-color: #39c181;
}
.explanation__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding-inline-start: 16px;
  list-style: disc;
}
.explanation__text {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #515258;
}
.explanation__text--placeholder {
  font-style: italic;
  color: #646464;
}
.explanation__footer {
  margin: 0;
  font-size: 12px;
  color: #646464;
}
/*# sourceMappingURL=alert-sending-explanation.component.css.map */
